// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__pCszY","th":"Table_th__K_xS2","td":"Table_td__HJwla","scroll":"Table_scroll__ugkAa"};